// extracted by mini-css-extract-plugin
export default {"card":"CarInitialInfo_card__PeAmn","header":"CarInitialInfo_header__Z+Zf0"};